import { ref } from 'vue'

const user = ref(null)
const isLoggedIn = ref(false)

export function useAuth() {
  const login = (email, password) => {
    if (email && password) {
      user.value = {
        email,
        name: email.split('@')[0]
      }
      isLoggedIn.value = true
      localStorage.setItem('user', JSON.stringify(user.value))
      return true
    }
    return false
  }

  const register = (email, password, name) => {
    if (email && password && name) {
      user.value = {
        email,
        name
      }
      isLoggedIn.value = true
      localStorage.setItem('user', JSON.stringify(user.value))
      return true
    }
    return false
  }

  const logout = () => {
    user.value = null
    isLoggedIn.value = false
    localStorage.removeItem('user')
  }

  const initAuth = () => {
    const savedUser = localStorage.getItem('user')
    if (savedUser) {
      user.value = JSON.parse(savedUser)
      isLoggedIn.value = true
    } else {
      // 默认设置为已登录状态（演示用）
      user.value = {
        email: 'panzhijie@example.com',
        name: 'PANZHIJIE'
      }
      isLoggedIn.value = true
      localStorage.setItem('user', JSON.stringify(user.value))
    }
  }

  return {
    user,
    isLoggedIn,
    login,
    register,
    logout,
    initAuth
  }
}
